import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {customer, customers} = api



/**
 * 查找
 */
export async function findCustomer(params) {
    return request({url: customer, method: 'get', data: params,})
}

/**
 * 创建
 */
export async function createCustomer(params) {
    return request({url: customers, method: 'post', data: params,})
}

/**
 * 更新
 */
export async function updateCustomer(params) {
    return request({url: customer, method: 'put', data: params,})
}

/**
 * 删除
 */
export async function deleteCustomer(params) {
    return request({url: customer, method: 'delete', data: params,})
}


/**
 * 查找列表
 */
export async function findCustomers(params) {
    return request({url: customers, method: 'get', data: params,})
}

/**
 * 删除
 */
export async function deleteCustomers(params) {
    return request({url: customers, method: 'delete', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/customerConfig.js